export default {
  feature: 'Feature',
  features: 'Features',
  featuresOf: '{{type}} Features',
  'feature.list.title': 'Feature Management',
  'feature.list.subtitle': 'Manage your application features effectively.',
  'feature.list.search.placeholder': 'Search features by name or description',
  'feature.info': 'Feature Information',
  'feature.form.title': 'Feature Title',
  'feature.form.description': 'Feature Description',
  'feature.form.assignments': 'Assignments',
  'feature.form.slug': 'Slug',
  'feature.form.slug.helper':
    'Stable identifier consumer apps reference in code. Lowercase letters, digits, underscores (max 50). Cannot be changed while the feature is active.',
  'feature.form.slug.invalid':
    'Slug must start with a lowercase letter and contain only lowercase letters, digits, and underscores (max 50 chars).',
  'feature.info.helper':
    'Provide a clear title, concise description, and appropriate type to define the feature',
  'feature.msg.deactivateBlocked': 'Deactivation Blocked',
  'feature.msg.deactivateBlockedDescription':
    'You cannot deactivate this feature because it is already in use for {{subscriptionName}}.',
  'feature.actions.navigateToSubscription': 'Navigate to Subscription',
  'feature.utilityInfo': 'Feature Utility Info',
  'feature.utility.cardTitle': 'Utility Counter Info',
  'feature.utility.helper':
    'Configure utility limits and consumption durations',
  'feature.utility.enabled': 'Enable Utility Limits?',
  'feature.utility.counter': 'Utility Counter',
  'feature.utility.duration': 'Utility Duration',
  'feature.usage': 'Usage',
  'feature.save.confirm.title': 'Save Options',
  'feature.save.confirm.description': 'Save as new one or update existing one',
  'feature.assigned.subscriptions': 'Assigned Subscriptions ({{count}})',
  'feature.subscriptions.helper':
    'To assign subscriptions, you can select from the available list of active subscriptions.',
  'feature.msg.unAssignConfirm': 'Are you sure to un-assign this Subscription?',
};
